import React, {useState, useEffect, useRef} from 'react';
import {FilterMatchMode} from 'primereact/api';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";
import {Dialog} from 'primereact/dialog';
import {connect} from "react-redux";
import moment from 'moment';
import {exportExcel, exportPdf} from "../shared/utility";
import {SplitButton} from "primereact/splitbutton";
import NewCostDialogue from "./dialogues/NewExpenseDialogue";
import {ExpenseService} from "../service/ExpenseService";


const ExpensesPage = (props) => {
    const {t, i18n} = useTranslation();

    let emptyExpenseItem = {
        id: null,
        date: null,
        description: null,
        amount: null,
        paymentMethod: null,
        notes: null,
        createdDate: null,
        status: null,
    };

    const [expense, setExpense] = useState(emptyExpenseItem);
    const [expenses, setExpenses] = useState(null);
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [expenseDialog, setExpenseDialog] = useState(false);
    const [deleteExpenseDialog, setDeleteExpenseDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [filters, setFilters] = useState({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const exportOptions = [
        {
            label: 'Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                exportExcel(expenses);
            }
        },
        {
            label: 'CSV',
            icon: 'pi pi-file',
            command: () => {
                exportCSV();
            }
        }
    ];

    const cols = [
        {field: 'id', header: t('id')},
        {field: 'date', header: t('date')},
        {field: 'description', header: t('description')},
        {field: 'amount', header: t('amount')},
        {field: 'paymentMethod', header: t('payment_method')},
        {field: 'notes', header: t('notes')},
        {field: 'createdDate', header: t('creation_date')},
    ];

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const expenseService = new ExpenseService();

    useEffect(() => {
        expenseService.getExpenses(props.partnerId).then(data => {
            setExpenses(fixDateField(data.content));
            setLoading(false)
        });
    }, []);

    const fixDateField = (data) => {
        return [...data || []].map(d => {
            d.date = new Date(d.date);
            return d;
        });
    }

    const paymentMethodBodyTemplate = (rowData) => {
        if (rowData.paymentMethod != null) {
            switch(rowData.paymentMethod) {
                case 'cash':
                    return t('cash');
                case 'credit_card':
                    return t('credit_card');
                case 'online_credit_card':
                    return t('online_payment');
                default:
                    return t('cash');
            }
        }
        return ''
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const addExpense = () => {
        setExpense(emptyExpenseItem);
        setSubmitted(false);
        setExpenseDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setExpenseDialog(false);
        setDeleteExpenseDialog(false);
    }

    const confirmDeleteExpense = (expense) => {
        setExpense(expense);
        setDeleteExpenseDialog(true);
    }

    const deleteExpense = () => {
        expenseService.deleteExpense(expense.id)
            .then(() => {
                let _expenses = expenses.filter(val => val.id !== expense.id);
                setExpenses(_expenses);
                setDeleteExpenseDialog(false);
                setExpense(emptyExpenseItem);
            })
    }

    const editExpense = (expense) => {
        setExpense({...expense});
        setExpenseDialog(true);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const onSelectionDetail = (e) => {
        setSelectedExpense(e.value)
        setExpenseDialog(true);
    }

    const dateBodyTemplate = (rowData) => {
        if (rowData.date != null) {
            return moment(rowData.date).format('DD.MM.YYYY HH:mm')
        }
        return ''
    }

    const creationDateBodyTemplate = (rowData) => {
        if (rowData.createdDate != null) {
            return moment(rowData.createdDate).format('DD.MM.YYYY HH:mm')
        }
        return ''
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <h5 className="m-0">{t('costs')}</h5>
                <span className="p-input-icon-right">
                    <i className="pi pi-add"/>
                    <Button label={t('add')} icon="pi pi-plus" className="p-button-success" onClick={addExpense}/>
                    <span> </span>
                    <i className="pi pi-export"/>
                    <SplitButton label={t('export')} icon="pi pi-download" className="p-button-help"
                                 style={{marginRight: "10px"}} onClick={() => exportPdf(cols, expenses)}
                                 model={exportOptions}/>
                    <span> </span>
                    <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder={t('search')}/>
                </span>
            </div>
        )
    }

    const header = renderHeader();
    let history = useHistory();

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {/*<Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editExpense(rowData)}/>*/}
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                        onClick={() => confirmDeleteExpense(rowData)}/>
            </React.Fragment>
        );
    }

    const deleteExpenseDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDialog}/>
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteExpense}/>
        </React.Fragment>
    );

    return (
        <div className="datatable-doc-demo col-12">
            <div className="card">
                <DataTable value={expenses} ref={dt} paginator className="p-datatable-products" header={header} rows={8}
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           rowsPerPageOptions={[10, 25, 50]}
                           dataKey="id" rowHover selection={selectedExpense} onSelectionChange={onSelectionDetail}
                           filters={filters} filterDisplay="menu" loading={loading} responsiveLayout="scroll"
                           emptyMessage={t('no_expense_found')}
                           currentPageReportTemplate={t('Showing {first} to {last} of {totalRecords} entries')}>
                    <Column field="date" header={t('date')} sortable dataType="date" body={dateBodyTemplate}></Column>
                    <Column field="description" header={t('description')} sortable></Column>
                    <Column field="notes" header={t('notes')} sortable></Column>
                    <Column field="paymentMethod" header={t('payment_method')} sortable body={paymentMethodBodyTemplate}></Column>
                    <Column field="amount" header={t('amount')} sortable dataType="count"></Column>
                    <Column field="createdDate" header={t('creation_date')} sortable dataType="date"
                            body={creationDateBodyTemplate}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{minWidth: '8rem'}}></Column>
                </DataTable>
            </div>
            <NewCostDialogue visible={expenseDialog} onHide={setExpenseDialog}/>
            <Dialog visible={deleteExpenseDialog} style={{width: '450px'}} header={t('confirm')} modal
                    footer={deleteExpenseDialogFooter} onHide={hideDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                    {expense && <span>{t('confirm_delete')}</span>}
                </div>
            </Dialog>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        partnerId: state.auth.userDetails.partner.id
    };
};

export default connect(mapStateToProps, null)((ExpensesPage));
